export function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
        return '0 B';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const isIntegerNumber = (value: string) => {
    if (value.length === 0) return false;
    if (value.length > 1 && value[0] === '0') return false;

    for (let i = 0; i < value.length; ++i) {
        if (!(value[i] <= '9' && value[i] >= '0')) return false;
    }

    return true;
};

export const truncateTitle = (title: string, length = 50) => {
    if (!title || !title.length) {
        return '';
    }
    return (
        title[0].toUpperCase() +
        (title.length > length
            ? title[length]
                ? title.slice(1, length) + '...'
                : title.slice(1, length - 1) + '...'
            : title.slice(1))
    );
};

export enum Time {
    Sec = 1000,
    Min = 60 * 1000,
    Hour = 60 * 60 * 1000,
    Day = 24 * 60 * 60 * 1000,
    Week = 7 * 24 * 60 * 60 * 1000,
}

export const dateDiff = (date1: Date, date2: Date, units: keyof typeof Time) =>
    Math.ceil(Math.abs(date1.getTime() - date2.getTime())) / Time[units];

export const objectsDiff = (source: Record<string, unknown> | undefined, target: Record<string, unknown>) => {
    const clone = { ...target };
    const result: string[] = [];
    Object.keys(source || {}).forEach((key) => {
        if (source?.[key] !== target[key]) {
            result.push(key);
        }
        delete clone[key];
    });
    result.push(...Object.keys(clone));
    return result;
};
